import { useEffect, useRef, useState } from 'react';
import Mark from './Mark';
import { assetUrl, resolveImage } from '../lib/images';

// Convention from the old site: "photo.jpg" may have a tiny "photolow.jpg" next to it.
const lowRes = (src) => `${src.replace(/\.(jpe?g|png|webp)$/i, '')}low.jpg`;

/**
 * A lazy-loaded image that fades in over its blurred low-res twin.
 *  - fills its parent by default (object-fit: cover); use `natural` to keep the
 *    image's own proportions
 *  - `fallback` shows the iz mark when the file is missing
 */
export default function Photo({ src: wanted, alt = '', eager = false, natural = false, fallback = false, position, className = '' }) {
  const src = resolveImage(wanted);
  const [state, setState] = useState('loading');
  const [lowOk, setLowOk] = useState(true);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el && el.complete && el.naturalWidth > 0) setState('ready');
  }, [src]);

  if (!src || state === 'failed') {
    return fallback ? <span className={`photo-fallback ${className}`}><Mark /></span> : null;
  }
  return (
    <span className={`photo ${natural ? 'photo--natural' : ''} ${state === 'ready' ? 'is-ready' : ''} ${className}`}>
      {!natural && lowOk && state === 'loading' && (
        <img className="photo-low" src={assetUrl(lowRes(src))} alt="" aria-hidden="true" onError={() => setLowOk(false)} />
      )}
      <img
        ref={ref}
        className="photo-full"
        src={assetUrl(src)}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        fetchpriority={eager ? 'high' : undefined}
        decoding="async"
        style={position ? { objectPosition: position } : undefined}
        onLoad={() => setState('ready')}
        onError={() => setState('failed')}
      />
    </span>
  );
}
